<template>
  <div class="time-container">
    <div style="color: white;font-size: 1.5rem;font-weight: 600">{{ time }}</div>
    <div style="color: white;font-size: 0.9rem">{{ date }}</div>
  </div>
</template>

<script>
export default {
  name: "current-time",
  data() {
    return {
      time: '',
      date: '',
    }
  },
  mounted() {
    this.getNowTime();//进入页面调用该方法获取当前时间
    let myTimeDisplay = null

    myTimeDisplay = setInterval(() => {
      this.getNowTime(); //每秒更新一次时间
    }, 1000);
  },
  methods: {
    getNowTime() {
      let date = new Date();
      this.time = this.addZero(date.getHours()) + ':' + this.addZero(date.getMinutes())  + ':' + this.addZero(date.getSeconds());
      this.date = date.getFullYear() + '-' + this.addZero(date.getMonth() + 1) + '-' + this.addZero(date.getDate())
    },
    addZero(s) {
      return s < 10 ? ('0' + s) : s;
    },
  },
}
</script>

<style lang="scss" scoped>
.time-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
